import 'slick-carousel';

$('.top-mv-slides').slick({
  dots: false,
  arrows: false,
  fade: true,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  //variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 5000,
  speed: 1200
});

